import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import { IconButton } from '@mui/material';
import { MouseEvent } from 'react';
import { defineMessage, useIntl } from 'react-intl';

const archiveMessage = defineMessage({
  id: 'notifications.feed.archive',
  defaultMessage: 'Archivar',
});

export type NotificationFeedItemArchiveButtonProps = {
  onArchive: () => void;
};

/**
 * Per-item archive control for a notification row.
 */
export function NotificationFeedItemArchiveButton({
  onArchive,
}: NotificationFeedItemArchiveButtonProps) {
  const $t = useIntl().formatMessage;

  function handleClick(event: MouseEvent) {
    event.stopPropagation();
    onArchive();
  }

  return (
    <IconButton
      size="small"
      onClick={handleClick}
      title={$t(archiveMessage)}
      sx={{
        flexShrink: 0,
        p: 0.5,
        color: 'text.disabled',
        '&:hover': { color: 'text.secondary' },
        '& .MuiSvgIcon-root': { fontSize: 16 },
      }}
    >
      <ArchiveOutlinedIcon />
    </IconButton>
  );
}
